import React from "react";
import { NewsletterCta } from "./components/NewsletterCta";
import { Faq4 } from "./components/Faq4";
import { JoinCommunityCta } from "./components/JoinCommunityCta";
import { BlogListingPage } from "./components/BlogListingPage";
import { Footer } from "../components/shared/Footer";

export default function Page() {
  return (
    <div>
      <BlogListingPage />
      <NewsletterCta />
      <Faq4 />
      <JoinCommunityCta />
      <Footer />
    </div>
  );
}
